import { computed }           from 'mobx';
import { makeAutoObservable } from 'mobx';
import { NavigateOptions }    from 'react-router-dom';
import { Params }             from 'react-router-dom';
import { NavigateFunction }   from 'react-router-dom';
import { matchPath }          from 'react-router-dom';

export const KEY_SHOWS = 'shows';
export const KEY_STANDS = 'stands';
export const KEY_DEMANDS = 'demands';
export const KEY_DOCUMENTS = 'documents';
export const KEY_PROVIDERS_SHOW_MODAL = 'providers_show_modal';

class NavigationStore {
  currentPath = window.location.pathname;
  params: Params<string> = {};
  private navigateFunction: NavigateFunction|null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setup(navigateFunction: NavigateFunction) {
    this.navigateFunction = navigateFunction;
  }

  update(path: string, params: Params<string>) {
    this.currentPath = path;
    this.params = params;
  }

  push(to: string, options?: NavigateOptions) {
    if (this.navigateFunction) {
      this.navigateFunction(to, options);
    }
  }

  @computed
  get activeMenuKey() {
    const path = this.currentPath;
    if (matchPath('/salons/:showId', path)) return KEY_SHOWS
    if (matchPath('/salons/:showId/stands', path) || matchPath('/stands/:id', path)) return KEY_STANDS;
    if (matchPath('/salons/:showId/demandes', path) || matchPath('/demandes/:id', path)) return KEY_DEMANDS;
    if (matchPath('/salons/:showId/documents', path) || matchPath('/stands/:id/documents', path)) return KEY_DOCUMENTS;
    else return '';
  }
}

export const navigationStore = new NavigationStore();